import type { ProductStatus } from '@optiflow/types';
import { StatusBadge } from '@/components/ui/StatusBadge';

/** Reuses the shared status vocabulary so ACTIVE looks identical everywhere. */
export function ProductStatusBadge({ status }: { status: ProductStatus }) {
  return <StatusBadge status={status} />;
}
